import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { Organization } from '../models/organization'

import { Store } from './store'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends Store<Organization> {

  constructor(private api: ApiService) {
    super(new Organization({ }))
  }

  public findCurrent(id: string): void {
    this.api.findCurrent<Organization>(`organization_public/${id}`, this.subject, Organization)
  }

  public find(id: string): Observable<any> {
    return this.api.get(`organization_public/${id}`)
  }

  public findAll(ids: string[]): Observable<any> {
    return this.api.get(`organizations_public?filter_by_ids=${ids.join(',')}`)
  }
}
